export const enum
TeamNamesEnum {
    AdvisoryBoard = 'AdvisoryBoard',
    UNIVIE = 'UNIVIE',
    JYU = 'JYU',
    BUAS = 'BUAS',
    IWM = 'IWM',
    TAU = 'TAU',
    CFG = 'CFG',
    USAL = 'USAL',
    LSO = 'LSO',
    WUEB = 'WUEB',
    UBISOFT = 'UBISOFT',
    EXTERNAL = 'EXTERNAL',
    EX_MEMBERS = 'ExMembers'
}
